import { Button, TextField, Box, Typography } from '@mui/material'
import axios from 'axios'
import PageAppBar from 'components/PageAppBar'
import { base_url } from 'env'
import { useState } from 'react'
import { useNavigate } from 'react-router'
import { UserModel } from 'types'
import { toast } from 'react-hot-toast'

const initialUser: Omit<
  UserModel,
  'creationDate' | 'lastConnectionDate' | 'accountState'
> = {
  admin: false,
  login: '',
  password: '',
  firstName: null,
  lastName: null,
  email: '',
  phone: null,
}

export default function UserCreationPage() {
  const navigate = useNavigate()
  const [user, setUser] = useState(initialUser)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    // If the value is an empty string, store null for optional fields, otherwise store the value.
    const isOptionalField = ['firstName', 'lastName'].includes(name)
    setUser({ ...user, [name]: isOptionalField && value === '' ? null : value })
  }

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setUser({ ...user, phone: value === '' ? null : Number(value) })
  }

  const handleSubmit = () => {
    if (!user.login || !user.email || !user.password) {
      toast.error('Identifiant, email, et mot de passe sont obligatoires.')
      return
    }

    // --- FIX: Dynamically build the payload, omitting keys if their value is null ---
    const payload: { [key: string]: any } = {
      login: user.login,
      email: user.email,
      password: user.password,
    }

    if (user.firstName) {
      payload.firstName = user.firstName
    }
    if (user.lastName) {
      payload.lastName = user.lastName
    }
    if (user.phone) {
      payload.phone = user.phone
    }
    // Any field that is null in the state will now be completely omitted from the payload.

    axios
      .post(base_url + `/user/`, payload)
      .then((response) => {
        toast.success(`Utilisateur ${response.data.login} créé avec succès !`)
        navigate(`/user/${response.data.login}`)
      })
      .catch((error) => {
        // The global error handler will show a toast for server errors.
        console.error('User creation failed:', error)
      })
  }

  return (
    <PageAppBar pageName="Créer un Utilisateur">
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
          alignItems: 'center',
          padding: '2rem',
          maxWidth: '600px',
          margin: 'auto',
        }}
      >
        <Typography variant="h5">Nouveau Compte</Typography>

        <TextField
          required
          fullWidth
          name="login"
          label="Identifiant"
          value={user.login}
          variant="outlined"
          onChange={handleChange}
        />
        <TextField
          required
          fullWidth
          name="password"
          label="Mot de passe"
          type="password"
          value={user.password || ''}
          variant="outlined"
          onChange={handleChange}
        />
        <TextField
          required
          fullWidth
          name="email"
          label="Email"
          type="email"
          value={user.email}
          variant="outlined"
          onChange={handleChange}
        />
        <TextField
          fullWidth
          name="firstName"
          label="Prénom (Optionnel)"
          value={user.firstName || ''}
          variant="outlined"
          onChange={handleChange}
        />
        <TextField
          fullWidth
          name="lastName"
          label="Nom (Optionnel)"
          value={user.lastName || ''}
          variant="outlined"
          onChange={handleChange}
        />
        <TextField
          fullWidth
          name="phone"
          label="Numéro de téléphone (Optionnel)"
          type="number"
          value={user.phone || ''}
          variant="outlined"
          onChange={handlePhoneChange}
        />
        <Button
          variant="contained"
          color="success"
          onClick={handleSubmit}
          sx={{ mt: 2, minWidth: '150px' }}
        >
          Créer
        </Button>
      </Box>
    </PageAppBar>
  )
}
